import React, { useEffect, useState } from "react";
import { Breadcrumb, Row, Col, Card,Table, Button, Space, Tooltip, Input, Select } from 'antd';
import { fetchAdminApi, fetchApi } from "../../../services/api";
import { BankOutlined, EditOutlined } from '@ant-design/icons';
import { useHistory } from "react-router";
import constants from "../../../constants/constants";
import moment from "moment";
const { Option } = Select;
const { Search } = Input;
const UniversityMaster = () => {
	const history = useHistory();
	const [universityMasterData,setUniversityMasterData]=useState([]);
	const [listStates, setListStates] = useState([]);
	const savedFilters = JSON.parse(sessionStorage.getItem("universityMasterFilters"));
	const [selectedState, setSelectedState] = useState(savedFilters?.selectedState || null);
	const [searchText, setSearchText] = useState(savedFilters?.searchText || "");
	const [pagination, setPagination] = useState({
		current: savedFilters?.currentPage || 1,
		pageSize: savedFilters?.pageSize || 10,
	});
	const onEdit = (record) => {
		sessionStorage.setItem("editUniversityData", JSON.stringify(record));
		history.push("/edit-university");
	};
	useEffect(() => {
		sessionStorage.setItem(
			"universityMasterFilters",
			JSON.stringify({
				selectedState,
				searchText,
				currentPage: pagination.current,
				pageSize: pagination.pageSize,
			})
		);
	}, [selectedState, searchText, pagination]);
	useEffect(()=>{
		fetchStates();
	},[]);
	useEffect(() => {
		const unlisten = history.listen((location) => {
			const isGoingToEdit = location.pathname === "/edit-university";
			const isGoingBackToList = location.pathname === "/university-master";
			if (!isGoingToEdit && !isGoingBackToList) {
				sessionStorage.removeItem("universityMasterFilters");
			}
		});
		return () => {
			unlisten();
		};
	}, [history]);
	const columns = [
		{
			title: 'Actions',
			align: 'center',
			render: (record) => (
				<Space>
					<Tooltip title="Edit">
						<Button
							type="text"
							icon={<EditOutlined/>}
							onClick={() => onEdit(record)}
						/>
					</Tooltip>
				</Space>
			)
		},
		{
			title: 'State',
			dataIndex: 'State',
			key: 'State',
			sorter: (a, b) => {
				a = a.State || '';
				b = b.State || '';
				return a.localeCompare(b);
			},
		},
		{
			title: 'University',
			dataIndex: 'University_name',
			key: 'University_name',
			sorter: (a, b) => {
				a = a.University_name || '';
				b = b.University_name || '';
				return a.localeCompare(b);
			},
		},
		{
			title: 'City',
			dataIndex: 'city',
			key: 'city',
			sorter: (a, b) => {
				const cityA = (a.city || '').trim().toLowerCase();
				const cityB = (b.city || '').trim().toLowerCase();
				return cityA.localeCompare(cityB);
			}
		},
		{
			title: 'Custom',
			dataIndex: 'custom',
			key: 'custom',
			sorter: (a, b) => {
				a = a.custom || '';
				b = b.custom || '';
				return a.localeCompare(b);
			},
			render: (text) => {
				return (
					<>
						{text==="0"?"-":<BankOutlined className="icon-md" style={{ color: "grey" }}/>}
					</>
				);
			},
			align: 'center',
		},
		{
			title: 'Last Updated By',
			dataIndex: 'updated_by_name',
			key: 'updated_by_name',
			sorter: (a, b) => {
				a = a.updated_by_name || '';
				b = b.updated_by_name || '';
				return a.localeCompare(b);
			},
			render: (text)=>{
				return(
					<>
						<span>{text ? text : ""}</span>
					</>
				);
			}
		},
		{
			title: 'Last Updated On',
			dataIndex: 'updated_by',
			key: 'updated_by',
			align: 'center',
			sorter: (a, b) => new Date(a.updated_by) - new Date(b.updated_by),
			render: (value, object) => {
				return (
					<span>
						{object && object.updated_by_name && value
							? moment(value, "DD-MM-YYYY").format("MM/DD/YYYY")
							: ""}
					</span>
				);
			}
		},
	];
	useEffect(() => {
		fetchUniversityMasterInfo();
	},[selectedState, searchText]);
	//To get university master data
	const fetchUniversityMasterInfo = () => {
		const payload = {
			state_code: selectedState,
			search_value: searchText || ""
		};
		fetchAdminApi(`/university_master_list`, "post", payload).then(
			(res) => {
				if (res && res.data) {
					setUniversityMasterData(res.data);
				} else {
					setUniversityMasterData([]);
				}
			}
		);
	};
	const fetchStates = () => {
		fetchApi(`/states?country_code=US`, "get").then((res) => {
			if (res && res.data && res.data.length > 0) {
				setListStates(res.data);
			} else {
				setListStates([]);
			}
		});
	};
	const onChangeState = (value) =>{
		setSelectedState(value);
	};
	const selectFilterOption = (input,option)=>{
		return option.props.children.toLowerCase().indexOf(input.toLowerCase()) > -1 && option.props.children.toLowerCase().indexOf(input.toLowerCase()) < 1;
	};
	return(
		<>
			<div className="div">
				<div className="p-3">
					<Breadcrumb>
						<Breadcrumb.Item ><a onClick={() => {
							history.push({ pathname: "/admin-dashboard" });
						}}>Home</a></Breadcrumb.Item>
						<Breadcrumb.Item ><a onClick = {() => {
							history.push({ pathname :"/masters-menu" });
						}}>Masters</a></Breadcrumb.Item>
						<Breadcrumb.Item>Universities</Breadcrumb.Item>
					</Breadcrumb>
				</div>
				<div>
					<Row gutter={[24, 24]}>
						<Col xs={24} sm={24} md={24} lg={24}>
							<Card size="small" title={<span className="text-uppercase">{" "}University Master</span>} extra={<Space> <Select 
								onChange={onChangeState}
								value={selectedState}
								className="w-64"
								placeholder="State" 
								showSearch
								allowClear
								filterOption={selectFilterOption}>
								{listStates &&
									listStates.map((ListState) => (
										<Option key={ListState.region_code} value={ListState.region_code}>
											{ListState.region_name}
										</Option>))}
							</Select> <Search placeholder="State, University, City" value={searchText} onChange={(e) => setSearchText(e.target.value)}/> <Button className="edit-butoon" onClick={() => history.push({ pathname: "/add-university" })}
							>{constants.AddUniversity}</Button></Space>}>
								<span className="px-3">{ `${universityMasterData !== null?universityMasterData.length:0} record(s) found.` }</span>
								<Table
									dataSource={universityMasterData}
									columns={columns}
									pagination={{
										current: pagination.current,
										pageSize: pagination.pageSize,
										total: universityMasterData.length,
									}}
									onChange={(pag) => {
										setPagination({
											current: pag.current,
											pageSize: pag.pageSize,
										});
									}}
								/>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		</>
	);
};
export default UniversityMaster;